var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceptionPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.5C26.0711 16.5 27.75 14.8211 27.75 12.75C27.75 10.6789 26.0711 9 24 9C21.9289 9 20.25 10.6789 20.25 12.75C20.25 14.8211 21.9289 16.5 24 16.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.5V20.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 25.5V37.5H10.5V25.5",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 25.5V37.5H10.5V25.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25.5H9",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 25.5V24.5355C31.5 23.3989 31.0485 22.3089 30.2448 21.5052C29.4411 20.7015 28.3511 20.25 27.2145 20.25H20.7855C19.6489 20.25 18.5589 20.7015 17.7552 21.5052C16.9515 22.3089 16.5 23.3989 16.5 24.5355V25.5",
    fill: "#0000FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 25.5V24.5355C31.5 23.3989 31.0485 22.3089 30.2448 21.5052C29.4411 20.7015 28.3511 20.25 27.2145 20.25H20.7855C19.6489 20.25 18.5589 20.7015 17.7552 21.5052C16.9515 22.3089 16.5 23.3989 16.5 24.5355V25.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceptionPoi);
export default __webpack_public_path__ + "static/media/reception-poi.ce9e6e88b80801f487eeedb3ba58b7f3.svg";
export { ForwardRef as ReactComponent };